<nb-layout>
    <nb-layout-column>
        <nb-card *ngIf="validHash">
            <nb-card-header>{{ 'RAPPORT.VIEWER.TITEL' | translate:{klantReferentie: klantReferentie} }}</nb-card-header>
            <nb-card-body>

                <ngx-extended-pdf-viewer [src]="fileContent" useBrowserLocale="true" [showToolbar]="true"
                    [showSidebarButton]="true" [showFindButton]="true" [showPagingButtons]="true"
                    [showZoomButtons]="true" [showPresentationModeButton]="true" [showOpenFileButton]="false"
                    [showPrintButton]="true" [showDownloadButton]="true" [showBookmarkButton]="false"
                    [showSecondaryToolbarButton]="true" [showRotateButton]="false" [showHandToolButton]="false"
                    [showScrollingButton]="false" [showSpreadButton]="false" [showPropertiesButton]="false"
                    [filenameForDownload]="fileNameForDownload" (pageRendered)="onPageRendered()"
                    (progress)="onProgress($event)" (pdfLoaded)="pdfLoaded($event)"></ngx-extended-pdf-viewer>
            </nb-card-body>
        </nb-card>

        <nb-card *ngIf="!validHash && !loadingVisible" status="danger">
            <nb-card-header>{{ 'RAPPORT.VIEWER.MELDING.FOUT.TITEL' | translate }}</nb-card-header>
            <nb-card-body>{{ 'RAPPORT.VIEWER.MELDING.FOUT.ONGELDIGE_LINK' | translate }}</nb-card-body>
        </nb-card>

        <nb-card *ngIf="showError && !loadingVisible" status="danger">
            <nb-card-header>{{ 'RAPPORT.VIEWER.MELDING.FOUT.TITEL' | translate }}</nb-card-header>
            <nb-card-body>{{ 'RAPPORT.VIEWER.MELDING.FOUT.KAN_RAPPORT_NIET_OPENEN' | translate }}</nb-card-body>
        </nb-card>

    </nb-layout-column>
</nb-layout>

<dx-popup [(visible)]="loadingVisible" [width]="500" [height]="175" [showTitle]="false">
    <p>{{loadingMessage}}</p>
    <div>
        <div class="text-center">
            <dx-load-indicator [visible]="progresValue == 0 "></dx-load-indicator>
        </div>
        <dx-progress-bar [min]="0" [max]="100" [(value)]="progresValue" [showStatus]="true"
            [statusFormat]="formatStatus" [visible]="progresValue > 0"></dx-progress-bar>
    </div>
</dx-popup>